import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '网红塌房', path: '/category/wanghong-tafang' },
  { label: '反差视频', path: '/category/fansha-shipin' },
  { label: '八卦内幕', path: '/category/bagua-neimu' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm whitespace-nowrap transition-colors duration-200 font-label ${
                isActive(link.path)
                  ? 'text-foreground-950 font-medium'
                  : 'text-foreground-700/70 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <Link to="/" className="font-heading text-xl font-black tracking-wider text-foreground-950 whitespace-nowrap">
          每日大赛<span className="text-primary-500">黑料</span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/about"
            className={`text-sm whitespace-nowrap transition-colors duration-200 font-label ${
              isActive('/about')
                ? 'text-foreground-950 font-medium'
                : 'text-foreground-700/70 hover:text-foreground-950'
            }`}
          >
            关于我们
          </Link>
          <button
            className="w-8 h-8 flex items-center justify-center text-foreground-700/70 hover:text-foreground-950 transition-colors duration-200"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link
            to="/about"
            className="bg-primary-500 text-foreground-950 px-5 py-2 rounded-md text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
          >
            下载APP
          </Link>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-950"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm py-2 whitespace-nowrap font-label ${
                  isActive(link.path)
                    ? 'text-foreground-950 font-medium'
                    : 'text-foreground-700/70'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200/60 pt-3 mt-1">
              <Link
                to="/about"
                className={`text-sm py-2 block whitespace-nowrap font-label ${
                  isActive('/about')
                    ? 'text-foreground-950 font-medium'
                    : 'text-foreground-700/70'
                }`}
              >
                关于我们
              </Link>
              <Link
                to="/about"
                className="bg-primary-500 text-foreground-950 px-5 py-2 rounded-md text-sm font-label font-medium whitespace-nowrap inline-block mt-3 hover:bg-primary-600 transition-colors duration-200"
              >
                下载APP
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}